import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useMembers } from '@app/api/members/useMembers';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { MemberRoleView } from '@shared/ui/forms/inputs';

export default function UnfreezeMemberDialog({ close, data }) {
  const [loading, setLoading] = useState(false);
  const { unfreezeMember } = useMembers();
  const { t } = useTranslation();

  async function onSubmit() {
    setLoading(true);
    try {
      await unfreezeMember({ user_id: data.id });
      close();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <p>{t('are_sure_member_unfreeze')}</p>
          <MemberRoleView member={data} />
        </div>
        <Note
          marginTop
          type="warning"
          title={t('important')}
          content={t('member_unfreeze_note')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="unfreeze"
            loading={loading}
            onClick={onSubmit}
          >
            {t('unfreeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
